import { cn } from "@/lib/styles.utils";

type TagLabelProps = {
  className?: string;
  label: string;
  value: string | number;
};

const TagLabel = ({ className, label, value }: TagLabelProps) => {
  return (
    <div
      data-testid="tag-label"
      className={cn(
        "inline-flex items-center rounded-full bg-gray-100 px-4 py-1.5 gap-2",
        "text-sm text-gray-700",
        className,
      )}
    >
      <span className="text-[#666666]">{label}:</span>
      <span className="text-[#333333]">{value}</span>
    </div>
  );
};

export default TagLabel;
